import { ValidationFunction, ValidationArrayFunction, FormError } from '@/types'
import i18n from '@/GlobalResource';

export function isFilled(msg: string = 'Please fill the field'): ValidationFunction {
  return (value: string | null | undefined | boolean): boolean | string => !!value || i18n.t(msg).toString()
}

export function hasMaximumLength(maximumCharacter: number, msg: string = 'Field maximum length has been reached: '): ValidationFunction {
  return (value: string | null | undefined | boolean): boolean | string => (!value || typeof(value) !== 'string' || (value as string).length <= maximumCharacter) || i18n.t(msg, { maximum: maximumCharacter }).toString()
}

export function checkAtLeastOne(msg: string = 'Please check one option'): ValidationArrayFunction {
  return (value: string[]): boolean | string => value.length > 0 || i18n.t(msg).toString()
}

export function checkAllSelectedAtLeastOnce(availableChecks: string[], selectedChecks: string[]): boolean {
  const notSelectedChecks = availableChecks.filter(ac => !selectedChecks.includes(ac));
  return notSelectedChecks.length === 0;
}

export function isEmail(msg = 'Please enter a valid email'): ValidationFunction {
  return (value: string | null | undefined | boolean): boolean | string =>
    !value || (typeof value === 'string' && /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,})$/.test(value)) || i18n.t(msg).toString()
}

export function isAlphaNumerics(msg = 'Please enter alpha numerics only'): ValidationFunction {
  return (value: string | null | undefined | boolean): boolean | string =>
    !value || (typeof value === 'string' && /^([a-zA-Z0-9])*$/.test(value)) || i18n.t(msg).toString()
}

const countryCodes: Array<string> = ["AT", "BE", "BG", "CY", "CZ", "DE", "DK", "EE", "EL", "ES", "FI", "FR", "HR", "HU", "IE", "IT", "LT", "LU", "LV", "MT", "NL", "PL", "PT", "RO", "SE", "SI", "SK"]
export function isStartingWithCountryCode(msg = 'Please start with valid country code'): ValidationFunction {
  return (value: string | null | undefined | boolean): boolean | string =>
    !value || (typeof value === 'string' && value.length >= 2 && countryCodes.indexOf(value.slice(0,2)) >= 0) || i18n.t(msg).toString()
}

export function isChecked(msg = 'This needs to be checked'): ValidationFunction {
  return (value: string | null | undefined | boolean): boolean | string => value || i18n.t(msg).toString()
}

export function isConfirmed(msg = 'Please confirm', valueToBeSame: string): ValidationFunction {
  return (value: string | null | undefined | boolean): boolean | string => {
    return valueToBeSame === value || i18n.t(msg).toString()
  }
}
